import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { CatalogClient } from 'src/app/api/clients/catalogs';

interface CheckoutModalProps {
  open: boolean;
}

const CheckoutModal = ({ open }: CheckoutModalProps) => {
  const navigate = useNavigate();
  const { merchantId, catalogId } = useParams();

  const handleCheckout = () => {
    if (!merchantId || !catalogId)
      return alert(
        'Unable to find the merchant or catalog you are trying to activate. Try again.'
      );
    CatalogClient.intitiateCatalogCheckout(merchantId, catalogId).then(
      (data) => {
        data.data.redirect_url &&
          window.location.assign(data.data.redirect_url);
      }
    );
  };
  return (
    <Dialog open={open} sx={{ textAlign: 'center' }}>
      <DialogTitle>Activate Catalog</DialogTitle>
      <DialogContent>
        <Typography variant="body1">
          To make a catalog available for import to a Clover device, you need to
          activate it.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button variant="text" onClick={() => navigate('./..')}>
          Cancel
        </Button>
        <Button variant="flat" onClick={handleCheckout}>
          Checkout
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CheckoutModal;
